export default __webpack_public_path__ + "static/media/icon-baby-res.7cd2f390.png";